export default __webpack_public_path__ + "static/media/python.443b1286.png";